export default __webpack_public_path__ + "static/media/card.de16ec86.less";